export type RoutesConfig = {
  name: string; // slugified name
  path: string; // an absolute path
  text: string; // link text for navs
  isPrivate?: boolean; // set to true to block anonymous access
  access?: string[]; // access groups i.e. FREE
  meta?: MetaTags;
  routes?: RoutesConfig[]; // Optional to support nested routes
};

type MetaTags = {
  title: string;
  description?: string;
};

/*
    Currently routes are used in main nav and sub nav
    TODO migrate all routes and SEO meta tags from /utils/paths.js
 */

const routesConfig: RoutesConfig[] = [
  {
    // <--------- Authenticated Routes --------->
    name: "home",
    path: "/home",
    text: "Home",
    isPrivate: true,
    access: ["FREE"],
    meta: {
      title: "Home | AllBright",
    },
    routes: [
      {
        name: "recommendations",
        path: "/home",
        text: "Recommendations",
        isPrivate: true,
      },
      {
        name: "conversation",
        path: "/conversation",
        text: "Community Feed",
        isPrivate: true,
      },
    ],
  },
  {
    name: "connect",
    path: "/connect",
    text: "Connect",
    isPrivate: true,
    routes: [
      {
        name: "connect",
        path: "/connect",
        text: "Connections",
        isPrivate: true,
      },
      {
        name: "mentorship",
        path: "/connect/mentorship",
        text: "Find a Mentor",
        isPrivate: true,
      },
      {
        name: "your-mentorship",
        path: "/connect/your-mentorship",
        text: "Your mentorship",
        isPrivate: true,
      },
    ],
  },
  {
    name: "academy",
    path: "/academy",
    text: "Learning",
    routes: [
      {
        name: "academy",
        path: "/academy",
        text: "All Courses",
      },
      {
        name: "collections",
        path: "/academy/collections",
        text: "Collections",
      },
      {
        name: "my-learning",
        path: "/academy/my-learning",
        text: "My Learning",
      },
    ],
  },
  {
    name: "groups",
    path: "/groups",
    text: "Groups",
    isPrivate: true,
  },
  {
    name: "feed",
    text: "Feed",
    path: "/marketplace",
    isPrivate: true,
  },
  {
    name: "events",
    path: "/events",
    text: "Events",
    routes: [
      {
        name: "events",
        path: "/events",
        text: "Explore",
      },
      {
        name: "on-demand",
        path: "/events/on-demand",
        text: "On-Demand",
      },
      {
        name: "my-events",
        path: "/events/my-events",
        text: "My Events",
      },
      {
        name: "join",
        path: "/events/join",
        text: "Join",
        isPrivate: true,
      },
      {
        name: "success",
        path: "/events/success",
        text: "Success",
        isPrivate: true,
      },
    ],
  },
  {
    name: "member",
    path: "/member/:memberId",
    text: "Member",
    isPrivate: true,
  },
  {
    name: "messages",
    path: "/messages",
    text: "Messages",
    isPrivate: true,
  },
  {
    name: "onboarding",
    path: "/onboarding",
    text: "Onboarding",
    isPrivate: true,
  },
  {
    name: "account",
    path: "/account",
    text: "Account",
    isPrivate: true,
    routes: [
      {
        name: "details",
        text: "Personal details",
        path: "/account?details",
        isPrivate: true,
      },
      {
        name: "settings",
        text: "Notification settings",
        path: "/account?settings",
        isPrivate: true,
      },
    ],
  },

  // <--------- Unauthenticated Routes --------->

  {
    name: "edit",
    path: "/edit",
    text: "The AllBright Post",
  },
  {
    name: "digital",
    path: "/digital",
    text: "Digital",
    routes: [
      {
        name: "register",
        path: "/digital/register",
        text: "Register",
      },
      {
        name: "select-plan",
        path: "/digital/select-plan",
        text: "Select Plan",
      },
    ],
  },
  {
    name: "business",
    path: "/business",
    text: "For Businesses",
  },
  {
    name: "individuals",
    path: "/individuals",
    text: "For Individuals",
  },
  {
    name: "spaces",
    path: "/spaces",
    text: "Spaces",
  },
  {
    name: "learning",
    path: "/learning",
    text: "Learning",
  },
  {
    name: "memberships",
    path: "/memberships",
    text: "Memberships",
  },
  {
    name: "newsletter",
    path: "/newsletter",
    text: "Newsletter sign-up",
  },
  {
    name: "login",
    path: "/auth/login",
    text: "Log In",
  },
];

export default routesConfig;
